import classNames from 'classnames';
import TerpeneCard from 'components/TerpeneCard';
import styles from './ProductTerpenes.module.scss';

const ProductTerpenes = ({ terpeneLabels, terpenes = [] }) => {
  const firstFour = terpenes
    .map((value) =>
      terpeneLabels.find(
        ({ name: terpeneLabel }) =>
          value?.toLowerCase() === terpeneLabel?.toLowerCase()
      )
    )
    .filter((value) => value && value.image)
    .slice(0, 4);

  const terpeneLength = firstFour.length;

  return terpeneLength && terpeneLabels.length > 0 ? (
    <div className="mb-14 mb-xl-25">
      <h2 className="font-frl fs-15 fs-xxl-18 fw-900 mb-10 mb-sm-15 text-primary">
        Dominant Terpene Aromas and Use Cases
      </h2>
      <ul
        id="terpenes-wrapper"
        className={classNames(
          'd-flex flex-column flex-md-row list-unstyled',
          styles.wrapper
        )}
      >
        {firstFour.map((value) => {
          const {
            name: title,
            image: { url: imageUrl },
            aromas,
            use_cases: useCases,
          } = value;

          return (
            <TerpeneCard
              key={title}
              aromas={aromas}
              className={classNames({
                [styles.one_up]: terpeneLength === 1,
                [styles.two_up]: terpeneLength === 2,
                [styles.three_up]: terpeneLength === 3,
                [styles.four_up]: terpeneLength === 4,
              })}
              imageUrl={imageUrl}
              title={title}
              useCases={useCases}
            />
          );
        })}
      </ul>
    </div>
  ) : null;
};

export default ProductTerpenes;
